import { render, staticRenderFns } from "./TfootPockets.vue?vue&type=template&id=2d1ece72"
import script from "./TfootPockets.vue?vue&type=script&lang=js"
export * from "./TfootPockets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports